<form [formGroup]="permissionsForm">
  <div class="shipping-permissions" (click)="hidePopovers($event)">
    <div class="shipping-permission-block">
      <h2>Shipment Permissions?</h2>
      <div class="fx-layout-row fx-layout-xs-column">
        <div class="fx-flex-25">
          <div class="heading-18-bold-onyx" class="permission-shipments-label" id="create-shipments-label">
            Allow Shipment Services
          </div>
        </div>
        <div class="fx-flex-50">
          <div class="fx-layout-row fx-layout-xs-column">
            <mat-checkbox formControlName="isShippingAllowed" (click)="setFormToDirty()">Allowed</mat-checkbox>
          </div>
        </div>
      </div>
      @if (isShippingAllowedCtrl.value) {
        <div>
          <div class="fx-layout-row fx-layout-xs-column">
            <div class="fx-flex-25">
              <label class="columnLabel">Action</label>
            </div>
            <div class="fx-flex-50">
              <label class="columnLabel">Permission Level</label>
            </div>
          </div>
          <div class="fx-layout-row fx-layout-xs-column">
            <div class="fx-flex-25 manageShipments">
              <div class="heading-18-bold-onyx" class="permission-shipments-label" id="manage-shipments-label">
                Manage Shipments
                <img src="/assets/images/JMicons/info_outline.png" id="manage-shipments-info" width="20" placement="bottom"
                  [ngbPopover]="manageShipmentsPop" #popover="ngbPopover">
                </div>
              </div>
              <div class="fx-flex-50">
                <mat-form-field>
                  <mat-select formControlName="manageShipments" (click)="setFormToDirty()" id="select-persmission-level">
                    @for (level of permissionLevels; track level) {
                      <mat-option [value]="level.value">{{ level.name }}</mat-option>
                    }
                    @if (permissionsForm.get('manageShipments').hasError('required')) {
                      <mat-error>
                        Select Permission Level
                      </mat-error>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <hr class="divider" />
            <div class="fx-layout-row fx-layout-xs-column">
              <div class="fx-flex-25">
                <div class="heading-18-bold-onyx" class="permission-shipments-label" id="create-shipments-label">
                  Create Shipments
                  <img src="/assets/images/JMicons/info_outline.png" id="create-shipments-info" width="20" placement="bottom"
                    [ngbPopover]="createShipmentsPop" #popover="ngbPopover">
                  </div>
                </div>
                <div class="fx-flex-50">
                  <div class="fx-layout-row fx-layout-xs-column">
                    <!-- Currently hidden -->
                    @if (false) {
                      <div class="fx-flex-50">
                        <mat-checkbox formControlName="domesticShipmentsOnly" (click)="setFormToDirty()">Domestic Shipments Only</mat-checkbox>
                      </div>
                    }
                  </div>
                  <div class="fx-layout-row fx-layout-xs-column">
                    <div class="fx-flex-50 mr-5">
                      <mat-checkbox formControlName="allowShipmentsBelowValue" (click)="setFormToDirty()">Shipments Below Value</mat-checkbox>
                    </div>
                    <div class="fx-flex-50">
                      <mat-checkbox formControlName="allowShipmentsBelowCost" (click)="setFormToDirty()">Shipments Below Cost</mat-checkbox>
                    </div>
                  </div>
                  <div class="fx-layout-row fx-layout-xs-column">
                    <div class="fx-flex-50 mr-5">
                      <mat-form-field>
                        <mat-label>Shipment below value</mat-label>
                        <input matInput type="text" id="valueInput" formControlName="shipmentsBelowValue" (click)="setFormToDirty()" mask="separator.2"
                          thousandSeparator=","
                          [leadZero]="true" prefix="$">
                          @if (hasErrorOfType('shipmentsBelowValue', 'required')) {
                            <mat-error>
                              Please enter Shipment Below Value
                            </mat-error>
                          }
                        </mat-form-field>
                      </div>
                      <div class="fx-flex-50">
                        <mat-form-field>
                          <mat-label>Shipment below cost</mat-label>
                          <input matInput type="text" id="costInput" (click)="setFormToDirty()" formControlName="shipmentsBelowCost" mask="separator.2"
                            thousandSeparator=","
                            [leadZero]="true" prefix="$">
                            @if (hasErrorOfType('shipmentsBelowCost', 'required')) {
                              <mat-error>
                                Please enter Shipment Below Cost
                              </mat-error>
                            }
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }
              <div class="footer">
                <mat-card-actions align="end" class="fx-layout-row fx-layout-xs-column">
                  <button mat-raised-button color="primary" type="button" [disabled]="permissionsForm.invalid || !formIsDirty" (click)="onSubmit()">Save</button>
                </mat-card-actions>
              </div>
            </div>
          </div>
        </form>
        <hr class="divider" />

        <ng-template #manageShipmentsPop>
          <div class="row info-wrap" id="manageShipmentsPop">
            <div class="col-10 info-head heading-12-onyx mb-1">
              Allow Users to
            </div>
            <mat-icon class="col-2 close-wrap mb-1 text-right" width="12">close</mat-icon>
            <div class="col-12 info-body heading-onyx">
              View shipment details, edit shipments, buy labels, file claims, and complete other shipment-related activities.
            </div>
            <div class="col-12 info-head heading-12-onyx mb-1 mt-2">
              Permission Level
            </div>
            <div class="col-12 info-body heading-onyx">
              Manage shipments created by the entire organization or select Created by User from the drop-down to manage only
              shipments
              the user creates.
            </div>
          </div>
        </ng-template>

        <ng-template #createShipmentsPop>
          <div class="row info-wrap" id="createShipmentsPop">
            <div class="col-10 info-head heading-12-onyx mb-1">Optional permissions include:</div>
            <mat-icon class="col-2 close-wrap mb-1 text-right" width="12">close</mat-icon>
            <div class="col-12 info-body heading-onyx">
              <div>a. shipments below a specific value, and/or</div>
              <div>b. shipments below a specific cost.</div>
            </div>
          </div>
        </ng-template>

        <app-in-progress [loading]="isLoading"> </app-in-progress>